import { render, staticRenderFns } from "./TablePageUpdated.vue?vue&type=template&id=6e4da170"
import script from "./TablePageUpdated.vue?vue&type=script&lang=js"
export * from "./TablePageUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports